import { BlockArticlesType } from '../../models/Content';
import { transformCta } from '../../utils/transformers';
import { transformArticleCard } from '../ArticleCard/transformers';
import { BlockArticlesData } from './model';

export const transformToBlockArticles = (contentItem: BlockArticlesType): BlockArticlesData => ({
    id: contentItem.sys.id,
    title: contentItem.fields.title ?? '',
    displayOption: contentItem.fields.displayOption ?? 'standalone',
    colorOption: contentItem.fields.colorOption ?? 'color-no-background',
    articles: (contentItem.fields.articles || []).map(transformArticleCard),
    cta: transformCta(contentItem.fields.cta),
});
